import { gql } from '@apollo/client';

export const LIST_EVENTS=gql`
    query listEvents($first:Int){
        listEvents(first:$first){
        edge{
            id,
            nombre,
            fecha,
            lugar,
            alt,
            is_req_register
        },
        total
        }
    }
`;


export const GET_EVENT_PROFILE_ASIST=gql`
    query getEvent_getEventsProfileAsist($event_id:ID! $profile_uuid:ID!){
        getEvent(id:$event_id){
            id,
            nombre,
            fecha,
            lugar,
            alt,
            is_req_register
        },
        getEventsProfileAsist(profile_uuid:$profile_uuid event_id:$event_id){
            id,
            event_id,
            acreditaciones_profile_uuid,
            tickets_no,
            created_at,
            updated_at,
            deleted_at
        }        
    }
`;


export const CREATE_PROFILE_EVENT_ASIST=gql`
mutation createEventsProfileAsist($profile_uuid:ID! $input:inputEventProfileAsist!){
    createEventsProfileAsist(profile_uuid:$profile_uuid input:$input){
        id,
        event_id,
        acreditaciones_profile_uuid,
        tickets_no,
        created_at,
        updated_at,
        deleted_at
    }
  }
  
`;
